import { render } from "./AttachCourseDetailRecord.vue?vue&type=template&id=4617a0eb"
import script from "./AttachCourseDetailRecord.vue?vue&type=script&lang=js"
export * from "./AttachCourseDetailRecord.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jeniel/Works/tranggle/old-tranggle-www-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__